module.exports = __webpack_public_path__ + "static/media/gallery2.f8a6bae0.jpg";